import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Eye, EyeOff, CheckCircle2 } from "lucide-react";

export function PasswordField({ label, value, onChange, testId, autoComplete, show, onToggleShow }) {
  const [localShow, setLocalShow] = useState(false);
  const visible = show ?? localShow;
  const toggle = onToggleShow ?? (() => setLocalShow((v) => !v));
  return (
    <div>
      <Label>{label}</Label>
      <div className="relative">
        <Input
          type={visible ? "text" : "password"}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          data-testid={testId}
          autoComplete={autoComplete}
        />
        <button
          type="button"
          onClick={toggle}
          aria-label={visible ? "Ocultar senha" : "Mostrar senha"}
          data-testid={`${testId}-toggle`}
          className="absolute right-2 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-700"
        >
          {visible ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
        </button>
      </div>
    </div>
  );
}

export function PasswordRequirements({ rules }) {
  return (
    <ul className="space-y-1 bg-slate-50 border rounded p-2" data-testid="pwd-requirements">
      {rules.map((r) => (
        <li key={r.key} className={`flex items-center gap-1.5 text-xs ${r.ok ? "text-emerald-700" : "text-slate-500"}`}>
          {r.ok ? <CheckCircle2 className="w-3 h-3" /> : <span className="w-3 h-3 rounded-full border border-slate-400" />}
          {r.text}
        </li>
      ))}
    </ul>
  );
}
